import React, { useState } from "react";
import ProductAddToCart from "./ProductAddToCart";
import {
  globalFileServer,
  newGlobalFileServer,
  globalFileIcon,
} from "../../../../axiosInstance";
import ProductInfo from "../../productInfo/ProductInfo";
import PricesCompareTable from "./PricesCompareTable";

const ProductPage = ({ selectedProd, setImageModal }) => {
  const [_currSlide, setCurrSlide] = useState(1);
  const mediaArray = Array.isArray(selectedProd?.media)
    ? selectedProd.media
    : [];
  let defaultPath = null;
  let fallbackPath = null;
  for (let i = 0; i < mediaArray.length; i++) {
    const path = mediaArray[i]?.path;
    if (path) fallbackPath = path;
    if (!defaultPath && mediaArray[i]?.isDefault === true && path) {
      defaultPath = path;
    }
  }
  const [imgView, _setImgView] = useState(defaultPath || fallbackPath || false);

  const _settings = {
    rtl: window.innerWidth > 1000 ? true : false,
    dots: false,
    arrows: window.innerWidth > 1000 ? true : false,
    infinite: window.innerWidth > 1000 ? true : false,
    speed: 200,
    slidesToShow:
      window.innerWidth > 1000
        ? selectedProd.PathUrl && selectedProd.PathUrl.split(",").length < 3
          ? selectedProd.PathUrl.split(",").length
          : 3
        : 1,
    slidesToScroll:
      window.innerWidth > 1000
        ? selectedProd.PathUrl && selectedProd.PathUrl.split(",").length < 3
          ? selectedProd.PathUrl.split(",").length
          : 3
        : 1,
    afterChange: (index) => setCurrSlide(index + 1),
  };

  return (
    <div className="product-pop-up">
      <div className="product-img">
        <img
          loading="lazy"
          alt=""
          onClick={() => setImageModal(imgView)}
          src={
            imgView
              ? `${newGlobalFileServer}${imgView}`
              : `${globalFileServer}/placeholder.jpg`
          }
        />
        <div
          onClick={() => setImageModal(imgView)}
          className="img"
          style={{
            backgroundImage: selectedProd.PathUrl
              ? `url(${newGlobalFileServer}${imgView})`
              : `url(${globalFileServer}/placeholder.jpg)`,
          }}
        />
        <div className="price-btn">
          <ProductAddToCart
            element={selectedProd}
            haveInfo={false}
            retailCard
          />
        </div>
      </div>

      <div className="product-details">
        <div
          className="prod-info"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div style={{ flex: 1 }}>
            <ProductInfo selectedProd={selectedProd} />
            <div className="prod-info-quantity">
              {selectedProd.weightJump > 1 ? (
                <span>
                  <br />
                  <span>{selectedProd.weightJump}</span>
                  <span> יחי' של </span>
                  <span className="weight-quantity">
                    {selectedProd.weightDetails?.netContent}
                  </span>
                  <span>{selectedProd.weightDetails.unitOfMeasure}</span>
                </span>
              ) : null}
            </div>
          </div>
          <div className="kashrut">
            {selectedProd.kosherSupervision?.length &&
            selectedProd.kosherSupervision[0].supervisionAgency &&
            selectedProd.kosherSupervision[0]?.supervisionAgency.img?.path !==
              "19.svg" ? (
              <img
                loading="lazy"
                src={
                  globalFileIcon +
                  selectedProd.kosherSupervision[0].supervisionAgency.img.path
                }
                alt={selectedProd.kosherSupervision[0].supervisionAgency.name}
              />
            ) : null}
          </div>
        </div>
        <div>
          {selectedProd.Expired && (
            <p>
              תוקף: {new Date(selectedProd.Expired).toLocaleDateString("en-GB")}
            </p>
          )}
          {selectedProd.gtin && (
            <p>{selectedProd.gtin && `ברקוד: ${selectedProd.gtin}`}</p>
          )}
        </div>
        <PricesCompareTable selectedProd={selectedProd} />
      </div>
    </div>
  );
};

export default ProductPage;
